// Returns a percentage (0-100) for the bar width, clamped to [0, 100].
export function clampedTransactionPercentage(
  value: number,
  limit: number
): number {
  if (limit <= 0) return 0;
  return Math.max(0, Math.min(100, (value / limit) * 100));
}
